<template>
  <div>
    <div class="row">
      <label class="col-9 head-label">Options</label>
      <div class="col-3 add-option">
        <sc-button
          :disabled="hasAddExtraOption || !hasOptionSwitch"
          variant="secondary"
          size="sm"
          @click="handleClickAddOption"
          >เพิ่ม option เสริม</sc-button
        >
      </div>
    </div>
    <div
      v-for="(option, index) in serviceOptions"
      :key="index"
      class="option-group"
    >
      <div class="row">
        <div class="col-9 mt-4">
          <div v-if="index === 0">
            <label class="label mb-2">Title (option หลัก)</label>
          </div>
          <div v-else>
            <label class="label mb-2">Title (option เสริม)</label>
          </div>
          <el-input
            :value="option.title"
            :disabled="disabled || !hasOptionSwitch"
            :readonly="isShowOptions"
            class="mb-3"
            type="text"
            @input="handleInputOption(index, $event)"
          ></el-input>
        </div>
        <div class="text-end col-3">
          <sc-button
            v-if="!disabled"
            :disabled="
              option.is_show_delete_option !== 'hasOption' || !hasOptionSwitch
            "
            :readonly="isShowOptions"
            variant="danger"
            class="btn-delete"
            @click="handleClickRemoveOption(index)"
            >ลบ</sc-button
          >
        </div>
      </div>
      <!-- <label class="label mb-2" v-show="!isEmptyVariants(option.variants)"
        >Variants (ใส่ได้ไม่เกิน 40 ตัวอักษร)</label
      > -->
      <div
        v-for="(variant, variantIndex) in option.variants"
        :key="`${index}-${variantIndex}`"
        class="row mb-3 input"
      >
        <div class="variant-main-row input">
          <div class="variant-field">
            <label class="label-Variant"
              >{{ variantIndex + 1 }}. Variants ({{
                variant.title ? variant.title.length : 0
              }}/40)</label
            >
            <el-input
              type="text"
              :value="variant.title"
              :disabled="disabled || !hasOptionSwitch"
              :readonly="isShowOptions"
              :maxlength="40"
              @input="handleInputVariant(index, variantIndex, 'title', $event)"
            ></el-input>
          </div>
          <div v-if="isShowMaterialCode" class="variant-field">
            <label class="label-Variant">Material Code</label>
            <material-selector
              v-model="variant.material_code"
              :is-show-selector="true"
              :disabled="disabled || !hasOptionSwitch"
              @unitName="handleInputVariant(index, variantIndex, 'unit_name', $event)"
            ></material-selector>
          </div>
          <div v-if="isShowMaterialCode" class="variant-field variant-quantity">
            <label class="label-Variant">จำนวน{{ variant.unit_name }}</label>
            <material-quantity-selector
              v-model="variant.material_quantity"
              :disabled="disabled || !hasOptionSwitch"
            ></material-quantity-selector>
          </div>
          <div class="variant-actions">
            <div class="variant-action-controls">
              <el-checkbox
                class="checkbox center"
                :disabled="!hasOptionSwitch"
                :value="variant.is_out_of_stock"
                @input="
                  handleInputVariant(index, variantIndex, 'is_out_of_stock', $event)
                "
                >หมดสต๊อก</el-checkbox
              >
              <el-checkbox
                class="checkbox center"
                :disabled="!hasOptionSwitch"
                :value="variant.is_not_sale"
                @input="
                  handleInputVariant(index, variantIndex, 'is_not_sale', $event)
                "
                >ไม่ขาย</el-checkbox
              >
              <sc-button
                v-if="!disabled"
                :disabled="
                  variant.is_show_delete_option !== 'hasOption' || !hasOptionSwitch
                "
                variant="danger"
                class="btn-delete"
                @click="handleClickRemoveVariant(index, variantIndex)"
                >ลบ</sc-button
              >
            </div>
          </div>
        </div>
        <div
          v-if="shouldShowServiceProductSelector(option)"
          class="variant-product-row input"
        >
          <div class="variant-product-selector">
            <service-product-selector
              fixed-product-input-width
              :value="variant.serviceProduct || null"
              :disabled-product-ids="
                getSelectedServiceProductIds(variant.variant_id)
              "
              :disabled="disabled || !hasOptionSwitch"
              @input="
                handleInputVariant(index, variantIndex, 'serviceProduct', $event)
              "
            ></service-product-selector>
          </div>
        </div>
      </div>
      <div v-if="!disabled" class="row">
        <div class="offset-4 col-5">
          <sc-button
            :disabled="isShowOptions || !hasOptionSwitch"
            class="w-100"
            @click="handleClickAddVariant(index)"
            >เพิ่ม Variant</sc-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import { Input, Checkbox, MessageBox } from "element-ui";
import { isEmpty } from "ramda";
import { uuid } from "vue-uuid";
import { serviceType } from "@/lib/mapper";
import materialSelector from "@/lib/components/materialSelector";
import materialQuantitySelector from "@/lib/components/materialQuantitySelector";
import ServiceProductSelector from "./ServiceProductSelector";
import { getSelectedServiceProductIdsFromOptions } from "../utils/serviceForm";


export default {
  components: {
    ScButton,
    ElInput: Input,
    "el-checkbox": Checkbox,
    materialSelector,
    "material-quantity-selector": materialQuantitySelector,
    ServiceProductSelector,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowOption: false,
      oldServiceOptions: null,
    };
  },
  computed: {
    serviceOptions() {
      return this.value.serviceOptions;
    },
    hasDeleteOption() {
      return this.value.hasDeleteOption;
    },
    hasAddExtraOption() {
      return this.hasAddOptional();
    },
    isShowOptions() {
      return this.isShowOption;
    },
    hasOptionSwitch() {
      return this.value.hasOptionSwitch;
    },
    isShowMaterialCode() {
      return this.value.sapServiceType === 'NORMAL';
    },
    isServiceProductType() {
      return this.value.serviceType === serviceType.DOTLIFE_PRODUCT;
    },

  },
  methods: {
    isMainOption(option) {
      return option && option.extra_option !== true;
    },
    shouldShowServiceProductSelector(option) {
      return this.isServiceProductType && this.isMainOption(option);
    },
    createEmptyVariant(option) {
      const variant = {
        variant_id: uuid.v4(),
        title: "",
        is_out_of_stock: false,
        is_not_sale: false,
        is_show_delete_option: "hasOption",
        material_code: null,
        material_quantity: null,
        unit_name: null,
      };

      return this.isMainOption(option)
        ? { ...variant, serviceProduct: null }
        : variant;
    },
    getSelectedServiceProductIds(variantId) {
      return getSelectedServiceProductIdsFromOptions(
        this.value.serviceOptions,
        variantId
      );
    },
    hasAddOptional() {
      return this.value.serviceOptions.some((_, index) => index > 0);
    },
    async handleClickRemoveOption(index) {
      let serviceOptions;

      if (index === 0) {
        try {
          await MessageBox.confirm(
            "หากลบ Option หลัก ข้อมูล Option และราคาทุนจะหายไป",
            { confirmButtonText: "ตกลง", cancelButtonText: "ยกเลิก" }
          );
        } catch { return; }
        serviceOptions = [
          {
            id: uuid.v4(),
            title: "",
            extra_option: false,
            is_show_delete_option: "hasOption",
            variants: [
              this.createEmptyVariant({ extra_option: false }),
              this.createEmptyVariant({ extra_option: false }),
            ],
          },
        ];

        this.$emit("setEmptyServiceOptionCosts");
      } else {
        serviceOptions = this.value.serviceOptions.filter(
          (_, i) => index !== i
        );
      }

      this.$emit("input", serviceOptions);
    },
    handleClickRemoveVariant(optionIndex, variantIndex) {
      const serviceOptions = this.value.serviceOptions.map((option, oIndex) =>
        optionIndex === oIndex
          ? {
              ...option,
              variants: option.variants.filter(
                (_, vIndex) => vIndex !== variantIndex
              ),
            }
          : option
      );

      this.$emit("input", serviceOptions);
    },
    handleClickAddVariant(optionIndex) {
      const serviceOptions = this.value.serviceOptions.map((option, index) =>
        optionIndex === index
          ? {
              ...option,
              variants: [
                ...option.variants,
                this.createEmptyVariant(option)
              ]
            }
          : option
      );

      this.$emit("input", serviceOptions);
    },
    handleClickAddOption() {
      this.$emit("input", [
        ...this.value.serviceOptions,
        {
          id: uuid.v4(),
          title: "",
          extra_option: true,
          is_show_delete_option: "hasOption",
          variants: [
            {
              ...this.createEmptyVariant({ extra_option: true }),
              code_description_unit: null,
            }
          ]
        }
      ]);
    },
    handleInputOption(index, event) {
      const serviceOptions = this.value.serviceOptions.map((option, i) =>
        i === index ? { ...option, title: event } : option
      );

      this.$emit("input", serviceOptions);
    },
    handleInputVariant(optionIndex, variantIndex, name, event) {
      this.$emit("isCheckCombineOption", true);

      if (name === "title" && event && event.length > 40) {
        return;
      }

      let serviceOptions
      if (name === "unit_name") {
        serviceOptions = this.value.serviceOptions.map((option, index) =>
          optionIndex === index
            ? {
                ...option,
                variants: option.variants.map((variant, vIndex) =>
                  variantIndex === vIndex
                    ? {
                      ...variant,
                      unit_name: event.unitName,
                      code_description_unit: event.codeDescriptionUnit
                    }
                    : variant
                ),
              }
            : option
        );
      } else {
        serviceOptions = this.value.serviceOptions.map((option, index) =>
          optionIndex === index
            ? {
                ...option,
                variants: option.variants.map((variant, vIndex) =>
                  variantIndex === vIndex
                    ? { ...variant, [name]: event }
                    : variant
                ),
              }
            : option
        );
      }

      this.$emit("input", serviceOptions);
    },
    handleClickEditOption() {
      this.isShowOption = false;
      this.oldServiceOptions = this.value.serviceOptions;
    },

    handleClickResetOption() {
      this.isShowOption = true;
      const serviceOptions = this.oldServiceOptions;

      this.$emit("input", serviceOptions);
    },
    isEmptyVariants(variants) {
      return isEmpty(variants);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.input {
  margin-bottom: 17px;
}

.checkbox {
  margin-top: 0;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.option-group {
  padding: 20px 30px;
  margin-bottom: 15px;
  border: $border;

  &:nth-child(2n) {
    background: #ddd;
  }
}

.option {
  margin-bottom: 10px;
  padding: 0px;
}

.edit-option {
  margin-bottom: 10px;
  text-align: left;
}

.add-option {
  margin-bottom: 10px;
  text-align: right;
}

.head-label {
  margin-bottom: 5px;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.label-Variant {
  display: block;

  line-height: 1.6;
  font-size: 1rem;
}

.variant-main-row {
  display: grid;
  grid-template-columns:
    minmax(0, 1fr)
    minmax(0, 1fr)
    minmax(0, 0.65fr)
    minmax(0, 1.45fr);
  column-gap: 30px;
  align-items: end;
}

.variant-product-row {
  display: grid;
  grid-template-columns:
    minmax(0, 1fr)
    minmax(0, 1fr)
    minmax(0, 0.65fr)
    minmax(0, 1.45fr);
  column-gap: 30px;
  width: 100%;
}

.variant-product-selector {
  grid-column: 1 / -1;
  min-width: 0;
  width: 100%;
}

.variant-field {
  min-width: 0;
}

.variant-actions {
  grid-column: 4;
  display: flex;
  align-items: flex-end;
  min-width: 0;
  min-height: 40px;
}

.variant-action-controls {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  width: 100%;
  min-height: 40px;
  min-width: 0;
}

.variant-action-controls ::v-deep .el-checkbox__input {
  display: flex;
  align-items: center;
}

.variant-action-controls ::v-deep .el-checkbox__label {
  padding-left: 4px;
  line-height: 40px;
}

.variant-action-controls .checkbox {
  flex: 0 0 auto;
  height: 40px;
  margin-right: 0;
  white-space: nowrap;
}

.variant-action-controls .checkbox + .checkbox {
  margin-left: 0;
}

.variant-action-controls .btn-delete {
  flex: 0 0 72px;
  width: 72px;
  min-width: 72px;
  margin-left: 2px;
  padding-left: 8px;
  padding-right: 8px;
}
</style>
